import React from 'react';
import { Backdrop } from '@omilia/modal';

type Props = {
  children: React.ReactNode;
};

const ModalContainer = ({ children }: Props) => (
  <>
    <Backdrop />
    {children}
  </>
);

export default ModalContainer;
